import styled from 'styled-components';
import { IonCard } from '@ionic/react';

export const IonCardWrapper = styled(IonCard)`
  .small .time-duration {
    &.time-duration-seconds {
      font-size: 50%;
    }
    font-size: 100%;
  }
  
  .disable-card {
    position: absolute;
    left: 0;
    top: 0;
    right: 0.01rem;
    bottom: 0;
    background-image: repeating-linear-gradient(45deg, #e5e5e5, #e5e5e5 30px, #dbdbdb 30px, #dbdbdb 60px);
  }
  
  .status-label {
    ion-badge {
      border-radius: 0;
      flex: 1 0 auto;
    }
  }
`;
